// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","subscriptions":"subscriptions-2o5_m"};